import Responsive from './Responsive';
import SmoothScroll from './SmoothScroll';
import Accordion from './Accordion';
import SpNavi from './SpNavi';
import ToTop from './ToTop';
import bowser from 'bowser';
import matchheight from 'jquery-match-height';
import Swiper from 'swiper/dist/js/swiper.js';
import inview from 'jquery-inview';
import {TweenMax, TimelineLite} from "gsap";
/**
 * ブラウザごとにbodyへクラス付与
 */
if(bowser.msie === true) {
	$('body').addClass('ie');
}else if(bowser.msedge === true){
	$('body').addClass('edge');
}else if(bowser.firefox === true){
	$('body').addClass('ff');
}else if(bowser.tablet === true){
	$('body').addClass('tablet');
}
if(bowser.mobile === true){
	$('body').addClass('device--mobile');
	if(bowser.android === true) {
		$('body').addClass('device--mobile--android');
	}
}
/**
 * win osバージョンごとにbodyへクラス付与
 */
let os, ua = navigator.userAgent;
if (ua.match(/Win(dows )?NT 10\.0/)) {
	os = "win10";
}
else if (ua.match(/Win(dows )?NT 6\.3/)) {
	os = "win8_1";
}
else if (ua.match(/Win(dows )?NT 6\.2/)) {
	os = "win8";
}
else if (ua.match(/Win(dows )?NT 6\.1/)) {
	os = "win7";
}else{
	os = '';
}

$('body').addClass(os);
/**
 * デバイスごとに電話番号リンクの振り分け
 */
$(function(){
	let ua = navigator.userAgent;
	if(ua.indexOf('iPhone') > 0 && ua.indexOf('iPod') == -1 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0 && ua.indexOf('SC-01C') == -1 && ua.indexOf('A1_07') == -1 ){
		$('.tel-link').each(function(){
			let str = $(this).text();
			$(this).html($('<a>').attr('href', 'tel:' + str.replace(/-/g, '')).append(str + '</a>'));
		});
	}
});
/* ===============================================
Check responsive state
=============================================== */
const r = new Responsive();
/**
 * スマートフォン用ナビゲーション
 */
let param = {
	target:'#spnavi',
	trigger:'.btn_sp_navi',
	filter:'resposive_flg',
	speed:200
};
const spnavi = new SpNavi(param);
spnavi.exec();
/**
 * スムーススクロール
 */
const sms = new SmoothScroll();
sms.exec();
/**
 * ページ最上部へのリンク
 */
const totop = new ToTop('#totop',100,400);
totop.exec();
/**
 * faqのアコーディオン
 */
const ac = new Accordion($('.js-faq'));
ac.exec();
/**
 * グローバルナビ
 */
$(function(){
	$(window).on('load resize',function(){
		if(r.state()() === true){
			$(".js-has-child").hover(
				function(){
					$(this).find(".gnav-child").stop().fadeIn("300");
				},
				function(){
					$(this).find(".gnav-child").stop().fadeOut("300");
				}
			);
		}
	});

	/* home のみ fadeIn
	----------------------- */
	if($("body.home").length){
		$(window).on("scroll",function(){
			let scrl = $(window).scrollTop();
			let movieHeight = $(".home-movie").height();
			if(scrl >= movieHeight){
				$(".js-header-toggle").addClass("is-fixed");
			}else{
				$(".js-header-toggle").removeClass("is-fixed");
			}
		});
	}else{
		$(window).on("scroll",function(){
			let scrl = $(window).scrollTop();
			if(scrl > 100){
				// $(".js-header-toggle").addClass("is-fixed");
				// $(".js-header-toggle").stop().fadeIn();
			}else{
				// $(".js-header-toggle").removeClass("is-fixed");
				// $(".js-header-toggle").stop().fadeOut();
			}
		});
	}

	/* sp nav
	----------------------- */
	$(".js-appendto-spnavi").clone().appendTo('#spnavi .inner');
	$("#spnavi .has-child>a").after('<div class="toggle-child"><i class="fa fa-angle-down" aria-hidden="true"></i></div>');
	$(".toggle-child").on("click",function(){
		$(this).next(".gnav-child").slideToggle();
		$(this).toggleClass("active");
	});
});

/**
 * トップページ MV
 */
let homeMovieSlide = new Swiper ('.home-movie-slide-container', {
	loop: true,
	speed:1000,
	autoplay:5000,
	slidesPerView:1,
	effect:"fade"
});
/**
 * トップページ バナー
 */
let homeSlide = new Swiper ('.home-slide-container', {
	loop: true,
	speed:1000,
	slidesPerView:3,
	spaceBetween:9,
	navigation: {
		nextEl: '.home-slide-next',
		prevEl: '.home-slide-prev',
	},
	autoplay: {
		delay: 3000
	},
	breakpoints: {
		860:{
			slidesPerView:2,
			spaceBetween:10,
		},
		600:{
			slidesPerView:1,
			spaceBetween:10,
		}
	}
});
/**
 * トップページ MV下のアニメーション
 */
const homeTimeline = new TimelineMax();

$('.home-concept').on('inview',function(event, isInView, visiblePartX, visiblePartY){
	homeTimeline
	.to('.js-animate_001', .3, {autoAlpha: 1 ,delay : 0,ease: Power3.easeIn},0)
	.to('.js-animate_002', .3, {autoAlpha: 1 , delay : 0,ease: Power3.easeIn},0.2)
	.to('.js-animate_003', .3, {autoAlpha: 1 , ease: Power3.easeIn},0.3)
	.to('.js-animate_004', .3, {autoAlpha: 1,ease: Power3.easeIn},0.4)
	.to('.js-animate_005', .3, {autoAlpha: 1,ease: Power3.easeIn},0.5)
});

/**
 * ギャラリーのスライド
 */
$(".js-gallery").each( function(){
	let target = $(this).find(".js-gallery-slide");
	let targetThumb = $(this).find(".js-gallery-thumb");
	let swiper;
	//Swiper定義
	swiper = new Swiper(target, {
		loop: true,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		autoplay: {
    		delay: 3000
  		},
		effect:"fade"
	});
	//thumbnailでページネーション
	$(targetThumb).find("li").on("click",function(){
		let index;
		let slideindex;
		if(slideindex = $(this).data('slideindex')){
			index = slideindex;
		}else{
			index = $(this).index() + 1;
		}
		swiper.slideTo(index);
	});
});

/**
 * 下層ページのヘッダーアニメーション
 */
const lowerTimeline = new TimelineMax();

$('.js-contents_header').on('inview',function(event, isInView, visiblePartX, visiblePartY){
	lowerTimeline
	.to('.js-contents_header', .2, {autoAlpha: 1 ,delay : 0,ease: Power3.easeIn})
	.to('.js-contents_header-title', .3, {autoAlpha: 1 , delay : 0,ease: Power3.easeIn,onComplete:function(){
		TweenMax.staggerTo(".js-contents_header-nav-stagger" , 0.5 , {autoAlpha: 1} ,0.2,function(){
			TweenMax.to(".js-contents_header-nav-stagger p" , 0.5 , {autoAlpha: 1,paddingTop:0});
		});
	}})
	.to('.js-contents_header-nav', .4, {bottom:30,autoAlpha: 1 ,delay : 0, ease: Power1.easeIn})
});
